<template>
  <span class="mothSelectBox"
    ><el-popover ref="popover" placement="bottom-start" v-bind="$attrs" :close-delay="100" trigger="manual" v-model="visible">
      <div @click.stop>
        <div class="tips">请选择以下月份可进行合并计算:</div>
        <div class="month-head" v-if="visible">
          <i @click="preYear" class="month-head-arrow el-icon-arrow-left"></i>

          <el-date-picker v-model="year" type="year" style="width: 100px" prefix-icon value-format="timestamp" :clearable="false"> </el-date-picker>
          <i @click="nextYear" class="month-head-arrow el-icon-arrow-right"></i>
        </div>

        <div class="month-body">
          <div v-for="row in 3" :key="row" class="month-body-row">
            <div @click="selectMonth((row - 1) * 4 + col)" :class="isSelect((row - 1) * 4 + col)" v-for="col in 4" :key="col">{{ (row - 1) * 4 + col }}月</div>
          </div>
        </div>
        <div class="month-buttom">
          <!-- <div>已选月份数：{{ allMonths.length }}</div> -->
          <el-button size="mini" @click="visible = false"> 取消 </el-button>
          <el-button size="mini" type="primary" @click="onConfirm"> 确定 </el-button>
        </div>
      </div>
      <template slot="reference">
        <el-input v-if="!hideInput" ref="input" clearable :disabled="disabled" v-model="inputValue" @clear="clearInput" @focus="focus"></el-input>
        <span v-else class="reference-anchor"></span>
      </template> </el-popover
  ></span>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    value: {
      required: true,
    },
    format: {
      type: String,
      default: 'YYYY-MM',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideInput: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(val) {
        if (Array.isArray(val) && val.join(',') !== this.allMonths.join(',')) {
          this.$set(this, 'allMonths', [...val]);
        }
      },
      immediate: true,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        document.addEventListener('click', this.onOutsideClick, true)
      } else {
        document.removeEventListener('click', this.onOutsideClick, true)
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.allMonths.map((item) => moment(item).format(this.format)).join(',');
      },
      set() {
        return '';
      },
    },
  },
  data() {
    return {
      visible: false,
      moment,
      month: null,
      allMonths: [],
      year: +moment().startOf('year'),
    };
  },
  created() {
    window.moment = moment;
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onOutsideClick, true)
  },
  methods: {
    selectMonth(val) {
      const key = +moment(+this.year).month(val - 1);
      if (!this.allMonths.includes(key)) {
        this.allMonths.push(key);
      } else {
        this.allMonths.splice(this.allMonths.indexOf(key), 1);
      }
      this.emitChange();
    },
    isSelect(month) {
      const key = +moment(+this.year).month(month - 1);
      return `month-body-col${this.allMonths.includes(key) ? ' month-body-selected' : ''}`;
    },
    preYear() {
      let base = this.year || Date.now();
      this.year = +moment(+base).subtract(1, 'years');
    },
    nextYear() {
      let base = this.year || Date.now();
      this.year = +moment(+base).add(1, 'years');
    },
    focus() {
      this.visible = true;
    },
    onConfirm() {
      if(this.allMonths.length > 12) {
        this.$message.error('最多只能选择12个月份')
        return
      }
      this.visible = false;
      //排序处理
      let inputValue = this.inputValue ? this.inputValue.split(',').sort().join(',') : '';
      this.$emit('monthMulti', inputValue);
    },
    clearInput() {
      this.allMonths = [];
      this.emitChange();
    },
    init() {
      // 重置组件到初始状态
      this.visible = false;
      this.allMonths = [];
      this.month = null;
      this.year = +moment().startOf('year');
      this.emitChange();
    },
    emitChange() {
      this.$emit('input', this.allMonths);
      this.$emit('change', this.allMonths);
    },
    onOutsideClick(e) {
      const popover = this.$refs.popover
      const pop = popover && (popover.popperElm || (popover.$refs && popover.$refs.popper) || popover.$el)
      const ref = (popover && (popover.referenceElm || (popover.$refs && popover.$refs.reference))) || this.$el
      if ((pop && pop.contains(e.target)) || (ref && ref.contains(e.target))) return
      this.visible = false
    }
  },
};
</script>

<style lang="stylus" scoped>
.tips {
  color: #333;
  margin-bottom: 10px;
}
.mothSelectBox {
  display: inline-block;
  vertical-align: middle;
}
.month-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  ::v-deep .el-input__prefix {
    display: none;
  }
  ::v-deep .el-input__inner {
    outline: none;
  }
  .month-head-arrow {
    cursor: pointer;
    width: 20px;
  }
}
.month-body {
  margin-top: 10px;
  .month-body-row {
    display: flex;
    justify-content: space-between;
  }
  .month-body-col {
    margin: 5px;
    width: 30px;
    cursor: pointer;
    padding: 10px;
    text-align: center
  }
  .month-body-selected {
    background-color: #0BB78E;
    border-radius: 5px;
    color: #fff
  }
}
.month-buttom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px
}
.reference-anchor {
  display: inline-block;
  width: 1px;
  height: 20px;
  vertical-align: middle;
}
</style>
